import * as _ from "lodash";
import {ThreePLServiceDetails} from "../models/threepl-service-details.model";
import {ThreePLServicesFilters} from "../models/threepl-services-list.model";

export interface ThreePLServicesPushCriteria {
  searchTerm?: string;
  from: number;
  to: number;
  filters: ThreePLServicesFilters;
}

export function matchesServicesFilters(service: ThreePLServiceDetails | undefined, criteria: ThreePLServicesPushCriteria): boolean {
  if (!service) {
    return false;
  }
  const {searchTerm, from, to, filters} = criteria;
  const steps = service.fulfillmentStepInfoList ?? [];
  const serviceAccountIds = steps.map((step) => step.accountId);
  const serviceBranchIds = _.uniq(steps.flatMap((step) => step.branchIds ?? []));
  const tasksServiceAreaIds: string[] = [];
  const tasksDepotIds = _.uniq([service.pickup?.depotReference?.id, service.destination?.depotReference?.id].filter((id): id is string => !!id));

  return (!searchTerm || JSON.stringify(service).toLowerCase().includes(searchTerm.toLowerCase())) &&
    (service.pickup.notBefore >= from && service.destination.notAfter < to) &&
    (!filters.accountIds?.length || !!_.intersection(filters.accountIds, serviceAccountIds).length) &&
    (!filters.branchIds?.length || !!_.intersection(filters.branchIds, serviceBranchIds).length) &&
    (!filters.serviceAreaIds?.length || !!_.intersection(filters.serviceAreaIds, tasksServiceAreaIds).length) &&
    (!filters.depotIds?.length || !tasksDepotIds.length || _.intersection(filters.depotIds, tasksDepotIds).length > 0) &&
    (!filters.supplyAccountIds?.length || _.includes(filters.supplyAccountIds, service.supplierAccountReference.id)) &&
    (!filters.providerTypes?.length || _.includes(filters.providerTypes, service.providerType)) &&
    (!filters.programTypes?.length || _.includes(filters.programTypes, service.programType)) &&
    (!filters.serviceTypes?.length || _.includes(filters.serviceTypes, service.serviceType));
}
